import { RadioGroup, RadioGroupItem } from '~/components/ui/radio-group'
import { Label } from '~/components/ui/label'
import {
    FieldMetadata,
    unstable_useControl as useControl,
} from '@conform-to/react'
import { ElementRef, useEffect, useRef } from 'react'

type RadioGroupConformType = {
    meta: FieldMetadata<string>
    items: Array<{ value: string; label: string }>
    handleChange?: (value?: string, fieldName?: string) => void
    defaultValue?: string
}

export function RadioGroupConform({
    meta,
    items,
    handleChange,
    defaultValue,
}: RadioGroupConformType) {
    const radioGroupRef = useRef<ElementRef<typeof RadioGroup>>(null)
    const control = useControl(meta)

    useEffect(() => {
        if (defaultValue && control.value === undefined) {
            control.change(defaultValue)
        }
    }, [])

    return (
        <>
            <input
                ref={control.register}
                name={meta.name}
                defaultValue={meta.initialValue}
                tabIndex={-1}
                className='sr-only'
                onFocus={() => {
                    radioGroupRef.current?.focus()
                }}
            />
            <RadioGroup
                ref={radioGroupRef}
                className='flex flex-col gap-2'
                value={control.value ?? ''}
                onValueChange={(value) => {
                    control.change(value)

                    if (handleChange) {
                        handleChange(value, meta.name)
                    }
                }}
                onBlur={control.blur}
            >
                {items.map((item) => {
                    return (
                        <div
                            className='flex items-center gap-1'
                            key={item.value}
                        >
                            <RadioGroupItem
                                value={item.value}
                                id={`${meta.id}-${item.value}`}
                            />
                            <Label htmlFor={`${meta.id}-${item.value}`}>
                                {item.label}
                            </Label>
                        </div>
                    )
                })}
            </RadioGroup>
        </>
    )
}
